import React, { useEffect, useState } from "react";
import MainLayout from "../../../layouts/main_layout/main_layout";
import {
  addDoc,
  collection,
  doc,
  DocumentData,
  getDoc,
  query,
} from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { Model } from "survey-core";
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { getSurveyorDetails } from "../../../services/survey_services/survey_services";
import "./style.css";
import UserIdentification from "../components/user_identification/user_identification";
import { Card } from "@material-ui/core";
import PersonalDetails from "../components/personal_Details/personal_details";
import EducationDetails from "../components/education_work_details/education_details";
import Consent from "../components/consent/consent";
import { useFeedback } from "../../../providers/feedback/feedback";

interface Props {}

function SurveyResponse(props: Props) {
  const { showSnackbar } = useFeedback();
  const { id } = useParams();
  const firestore = useFirestore();
  const {} = props;
  const [surveyRecord, setSurveyRecord] = useState<DocumentData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [surveyModel, setSurveyModel] = useState<Model | null>(null);
  const [surveyorDetails, setSurveyorDetails] = useState<any>(null);
  const [surveyCode, setSurveyCode] = useState<string>("");
  const [deaneryName, setDeaneryName] = useState<string>("");
  const [parishName, setParishName] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [pincode, setPincode] = useState<number | "">("");
  const [fullName, setFullName] = useState<string>("");
  const [age, setAge] = useState<number | "">("");
  const [gender, setGender] = useState<{ id: number; value: string } | null>(
    null
  );
  const [contactDetails, setContactDetails] = useState<number | "">("");
  const [parentName, setParentName] = useState<string>("");
  const [emailId, setEmailId] = useState<string>("");
  const [motherName, setMotherName] = useState<string>("");
  const [consentAccepted, setConsentAccepted] = useState<boolean>(false);
  const [highestQualification, setHighestQualification] = useState<{
    id: number;
    value: string;
  } | null>(null);
  const [fieldOfStudy, setFieldOfStudy] = useState<{
    id: number;
    value: string;
  } | null>(null);
  const [currentOccupation, setCurrentOccupation] = useState<{
    id: number;
    value: string;
  } | null>(null);
  const [jobTitle, setJobTitle] = useState<string>("");
  const [industry, setIndustry] = useState<{
    id: number;
    value: string;
  } | null>(null);
  const [bloodGroup, setBloodGroup] = useState<{
    id: number;
    value: string;
  } | null>(null);
  const [currentlyResiding, setCurrentlyResiding] = useState<{
    id: number;
    value: string;
  } | null>(null);
  const [companyName, setCompanyName] = useState<string>("");
  const [consent, setconsent] = useState<boolean>(false);
  const [bloodDonate, setBloodDonate] = useState<boolean>(true);
  const [surveyStep, setSurveyStep] = useState(1);
  const [customFieldOfStudy, setCustomFieldOfStudy] = useState("");
  const [customOccupation, setCustomOccupation] = useState("");
  const [customIndustry, setCustomIndustry] = useState("");

  const getSpecificRecord = async () => {
    setIsLoading(true);
    try {
      const docRef = doc(firestore, "survey", id!);
      const docSnap = await getDoc(docRef);
      setIsLoading(false);
      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        setSurveyRecord(docSnap.data());
        const surveyJson = surveyRecord?.surveyQuestionaire;
        let surveyModel;
        if (surveyJson) {
          surveyModel = new Model(surveyJson);
          setSurveyModel(surveyModel);
        }
        return docSnap.data();
      } else {
        console.log("No such document!");
        return null;
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      setIsLoading(false);
      return null;
    }
  };

  function getSurveyorDetailsById(surveyId: string) {
    getSurveyorDetails(surveyId)
      .then((res:any) => {
        setSurveyorDetails(res?.data);
      })
      .catch((e: any) => {
        setSurveyorDetails(null);
      });
  }

  useEffect(() => {
    getSpecificRecord();
  }, []);

  useEffect(() => {
    surveyModel?.setValue("deaneryName", surveyorDetails?.deaneryName);
    surveyModel?.setValue("parishName", surveyorDetails?.parishName);
  }, [surveyorDetails]);

  function submitedSurvey() {
    let date = new Date();
    const finalResponse = {
      checksum: Date.now(), // Generate a unique checksum
      answers: {
        surveyrCode: surveyCode,
        deaneryName: deaneryName,
        parishName: parishName,
        address: address,
        pincode: pincode,
        fullName: fullName,
        age: age,
        gender: gender,
        contactDetails: contactDetails,
        parentName: parentName,
        emailId: emailId,
        bloodGroup: bloodGroup,
        isWillingToDonate: bloodDonate,
        highestQualification: highestQualification,
        fieldOfStudy: fieldOfStudy,
        currentOccupation: currentOccupation,
        jobTitle: jobTitle,
        industry: industry,
        companyName: companyName,
        consent: consent,
        customFieldOfStudy: customFieldOfStudy,
        customOccupation: customOccupation,
        customIndustry: customIndustry,
        consentAccepted: consentAccepted,
        currentlyResiding: currentlyResiding,
        createdAt: date.toISOString(),
        updatedAt: date.toISOString(),
      },
    };
    const surveyResponsesCollection = collection(
      firestore,
      `survey/${id}/surveyResponses`
    );
    addDoc(surveyResponsesCollection, finalResponse)
      .then((res) => {
        showSnackbar("Response submitted successfully");
        setSurveyStep(1);
      })
      .catch((e) => {
        showSnackbar("Something went wrong");
      });
  }

  return (
    <MainLayout>
      {/* <Box
        display="flex"
        my={3}
        width="100%"
        maxWidth="900px"
        mx="auto"
        overflow="hidden"
        flexDirection="column"
      >
        surveyModel && <Survey model={surveyModel} />}  
      </Box> */}
      <Card style={{ marginTop: 32, marginBottom: 32 }}>
        <Box display={"flex"} flexDirection={"column"} mx={3} my={2}>
          <Box my={2}>
            <Typography
              variant="h4"
              textAlign={"left"}
              fontWeight={500}
              color="#19b394"
            >
              Youth Survey - 2025
            </Typography>
            <Typography variant="h6" color="#909090" mt={1}>
              The Youth Survey feature aims to collect and store parish youth
              data systematically in our database. This initiative will help in
              organizing and analyzing youth information efficiently.
            </Typography>
          </Box>
          <Box>
            {surveyStep == 1 && (
              <UserIdentification
                surveyCode={surveyCode}
                deaneryName={deaneryName}
                parishName={parishName}
                setSurveyCode={setSurveyCode}
                setDeaneryName={setDeaneryName}
                setParishName={setParishName}
                address={address}
                setAddress={setAddress}
                pincode={pincode}
                setPincode={setPincode}
                setSurveyStep={setSurveyStep}
                surveyStep={surveyStep}
              />
            )}
            {surveyStep == 2 && (
              <PersonalDetails
                fullName={fullName}
                setFullName={setFullName}
                age={age}
                setAge={setAge}
                gender={gender}
                setGender={setGender}
                contactDetails={contactDetails}
                setContactDetails={setContactDetails}
                parentName={parentName}
                setParentName={setParentName}
                email={emailId}
                setEmail={setEmailId}
                setSurveyStep={setSurveyStep}
                surveyStep={surveyStep}
                bloodGroup={bloodGroup}
                setBloodGroup={setBloodGroup}
                bloodDonate={bloodDonate}
                setBloodDonate={setBloodDonate}
                currentlyResiding={currentlyResiding}
                setCurrentlyResiding={setCurrentlyResiding}
              />
            )}
            {surveyStep == 3 && (
              <EducationDetails
                highestQualification={highestQualification}
                setHighestQualification={setHighestQualification}
                fieldOfStudy={fieldOfStudy}
                setFieldOfStudy={setFieldOfStudy}
                currentOccupation={currentOccupation}
                setCurrentOccupation={setCurrentOccupation}
                jobTitle={jobTitle}
                setJobTitle={setJobTitle}
                industry={industry}
                setIndustry={setIndustry}
                companyName={companyName}
                setCompanyName={setCompanyName}
                address={address}
                setAddress={setAddress}
                pincode={pincode}
                setPincode={setPincode}
                consent={consent}
                setconsent={setconsent}
                setSurveyStep={setSurveyStep}
                surveyStep={surveyStep}
                customFieldOfStudy={customFieldOfStudy}
                customOccupation={customOccupation}
                customIndustry={customIndustry}
                setCustomFieldOfStudy={setCustomFieldOfStudy}
                setCustomOccupation={setCustomOccupation}
                setCustomIndustry={setCustomIndustry}
              />
            )}
            {surveyStep == 4 && (
              <Consent
                consentAccepted={consentAccepted}
                setConsentAccepted={setConsentAccepted}
                setSurveyStep={setSurveyStep}
                surveyStep={surveyStep}
                onSubmit={() => {
                  submitedSurvey();
                }}
              />
            )}
          </Box>
        </Box>
      </Card>
    </MainLayout>
  );
}

export default SurveyResponse;
